<mat-card class="card-password">
  <div class="font-extrabold text-2xl text-center">
    Existe tarifário com esse trecho, o tarifário <br />existente será desativo
    para a criação desse novo.
  </div>
  <div class="flex justify-around items-center mt-5 -mx-2">
    <button mat-flat-button class="btn-tg w-1/12" [mat-dialog-close]="false">
      Cancelar
    </button>
    <button mat-flat-button class="btn-tg w-1/12" [mat-dialog-close]="true">
      Ok
    </button>

    <!--    <button-->
    <!--      mat-flat-button-->
    <!--      class="btn-tg-cancel w-1/12"-->
    <!--      [mat-dialog-close]="false"-->
    <!--    >-->
    <!--      Não-->
    <!--    </button>-->
  </div>
</mat-card>
